<script>

import axios from 'axios';

import ElForm from "element-ui/packages/form/src/form.vue";
import ElCheckbox from "element-ui/packages/checkbox/src/checkbox.vue";
import ElButton from "element-ui/packages/button/src/button.vue";
import ElInput from "element-ui/packages/input/src/input.vue";
// import ElDatePicker from "element-ui/packages/date-picker/src/picker/date-picker";
// import ElSelect from "element-ui/packages/select/src/select.vue";
// import ElOption from "element-ui/packages/select/src/option";
import ElRow from "element-ui/packages/row/src/row";

export default {
  components: {
    ElRow,
    ElInput,
    ElButton,
    ElCheckbox,
    // ElDatePicker,
    // ElSelect,
    // ElOption,
    ElForm
  },
  props: {
    settings: Object,
    showSubmitButton: Boolean,
  },
  data() {
    
    let leadAdditionalFields = this.settings.lead.fields
        .filter(i => i.type === 'additional' && i.additionalSource === 'lead')
        .map(i => {
          return {AdditionalTypeId: i.additionalId, Value: i.additionalType === 'bool' ? false : ''};
        });
    
    let leadAdditionalReferences = {};
    for (let leadField of leadAdditionalFields) {
      leadAdditionalReferences[leadField.AdditionalTypeId] = leadField;
    }

    return {
      isSuccess: false,
      isFailed: false,
      load: false,
      agreementUrl: null,
      pdnHtml: null,
      policyHtml: null,
      leadAdditionalReferences,
      options: {
        countries: [],
        passportTypes: [{
          id: 1,
          name: 'Общегражданский'
        }, {
          id: 2,
          name: 'Загранпаспорт'
        }, {
          id: 3,
          name: 'Свидетельство о рождении'
        }]
      },
      form: {
        agreeOffer: false,
        agreePdn: false,
        agreePolicy: false,
        fullName: '',
        tourDates: [],
        passportType: 1,
      },
      leadData: {
        PartnerId: this.settings.connect.partnerId,
        WidgetId: this.settings.connect.widgetId,
        YandexClientId: this.getYClientID(),
        GoogleClientId: this.getGoogleClientID(),
        CreateAgreement: false,
        FirstName: '',
        LastName: '',
        MiddleName: '',
        Phone: '',
        Email: '',
        Birthday: null,
        PassportType: '',
        PassportNumber: '',
        PassportDate: null,
        PassportDateEnd: null,
        PassportByWhom: '',
        PassportRusSer: '',
        PassportRusNumber: '',
        PassportRusDate: null,
        PassportRusByWhom: '',
        BirthdayCertificate: '',
        BirthdayCertificateDate: null,
        Address: '',
        BudgetFrom: 0,
        Adults: 0,
        Children: 0,
        StartDate: null,
        EndDate: null,
        BudgetTo: 0,
        CountryId: null,
        LeadComment: '',
        LeadAdditionalValues: leadAdditionalFields,
        ClientAdditionalValues: [],
      },
      rules: this.getRules(),
    };
  },
  methods: {
    getRules() {
      let rules = {};
      for (let field of this.settings.lead.fields) {
        if (field.type === 'passportData' && field.required) {
          if (field.passportType === 'multiple' || field.passportType === 'select' || field.passportType === 'rus') {
            rules.passportRus = [
              { required: true, validator: this.validateRussianPassport, trigger: 'blur' },
            ];
          }
          if (field.passportType === 'multiple' || field.passportType === 'select' || field.passportType === 'foreign') {
            rules.passportForeign = [
              { required: true, validator: this.validateForeignPassport, trigger: 'blur' },
            ];
            rules.passportDates = [
              { required: true, validator: this.validatePassportDates, trigger: 'blur' },
            ];
          }
        } else {
          let prop = field.type !== 'additional' ? field.type : 'additional_' + field.additionalId;
          let validations = [];
          
          if (prop === 'fullName' && field.required) {
            validations.push({ required: true, message: 'Введите имя и фамилию', trigger: 'blur' });
          } else if (prop === 'firstName' && field.required) {
            validations.push({ required: true, message: 'Введите имя', trigger: 'blur' });
          } else if (prop === 'lastName' && field.required) {
            validations.push({ required: true, message: 'Введите фамилию', trigger: 'blur' });
          } else if (prop === 'middleName' && field.required) {
            validations.push({ required: true, message: 'Введите отчество', trigger: 'blur' });
          } else if (prop === 'birthday' && field.required) {
            validations.push({ required: true, message: 'Введите дату рождения', trigger: 'change' });
          } else if (prop === 'phone') {
            validations.push({ required: field.required, message: 'Введите телефон', trigger: 'blur', validator: this.validatePhone });
          } else if (prop === 'email') {
            validations.push({ required: field.required, message: 'Введите email', trigger: 'blur', validator: this.validateEmail  });
          } else if (prop === 'description' && field.required) {
            validations.push({ required: true, message: 'Введите комментарий', trigger: 'blur' });
          } else if (prop === 'address' && field.required) {
            validations.push({ required: true, message: 'Введите адрес', trigger: 'blur' });
          } else if (prop === 'additional' && field.required) {
            validations.push({ required: true, message: `Поле "${field.label}" не указано`, trigger: 'blur' });
          } else if (prop === 'country' && field.required) {
            validations.push({ required: true, message: 'Выберите страну', trigger: 'change' });
          } else if (prop === 'tourDates' && field.required) {
            validations.push({ required: true, message: 'Выберите даты поездки', trigger: 'change' });
          } else if (prop === 'touristsCount' && field.required) {
            validations.push({ required: true, message: 'Укажите количество взрослых и детей', trigger: 'change', validator: this.validateTouristsCount });
          } else if (prop === 'adultsCount' && field.required) {
            validations.push({ required: true, message: 'Укажите количество взрослых', trigger: 'change', validator: this.validateTouristsCount });
          } else if (prop === 'budget' && field.required) {
            validations.push({ required: true, message: 'Укажите бюджет', trigger: 'change', validator: this.validateBudget });
          }
          
          if (validations.length) {
            rules[prop] = validations;
          }
        }
      }
      
      return rules;
    },
    getYClientID() {
      var match = document.cookie.match('(?:^|;)\\s*_ym_uid=([^;]*)');
      return (match) ? decodeURIComponent(match[1]) : false;
    },
    getGoogleClientID()
    {
      var match = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)');
      var raw = (match) ? decodeURIComponent(match[1]) : null;
      if (raw)
      {
        match = raw.match(/(\d+\.\d+)$/);
      }
      var gacid = (match) ? match[1] : null;
      if (gacid)
      {
        return gacid;
      }
    },
    handleSubmit() {
      this.submitLead(() => {
        this.isSuccess = true;
      }, () => {
        this.isFailed = true;
      });
    },
    submitLead(onSuccess, onFail) {
      this.$refs.leadForm.validate()
        .then(() => {
          let leadData = this.leadData;
          
          if (this.form.fullName) {
            let parts = this.form.fullName.split(' ');
            if (parts.length > 0) {
              leadData.FirstName = parts[0];
            }

            if (parts.length > 1) {
              leadData.LastName = parts[1];
            } else {
              leadData.LastName = '-';
            }

            if (parts.length > 2) {
              leadData.MiddleName = parts[2];
            }
          }

          if (!this.form.PassportNumber && this.form.BirthdayCertificate) {
            leadData.PassportNumber = this.form.BirthdayCertificate;
            leadData.PassportDate = this.form.BirthdayCertificateDate;
          }
          
          if (this.form.tourDates && this.form.tourDates.length) {
            leadData.StartDate = this.form.tourDates[0];
            leadData.EndDate = this.form.tourDates[1];
          }
          
          if (leadData.CountryId === null) {
            leadData.CountryId = 0;
          }

          leadData.Referrer = window.location.href;
          
          this.load = true;

          let afterSave = resp => {
            return new Promise((resolve, reject) => {
              this.load = false;
              
              if (onSuccess) {
                onSuccess(resp);
              }
              
              if (this.settings.lead.redirectUrl) {
                window.location.href = this.settings.lead.redirectUrl;
              }
              
              resolve();
            });
          };

          let onRejected = () => {
            return new Promise((resolve, reject) => {
              this.load = false;
              if (onFail) {
                onFail();
              }
              reject();
            });
          };

          return fetch(`${this.settings.connect.host}/tourclient/Cabinet/order/CreateOrderFromWidget`, {method: 'POST', headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }, body:JSON.stringify(leadData)})
            .then((response) => response.json())
            .then(createResult => {
              return new Promise((resolve, reject) => {
                if (createResult.ResultQueryInfo && createResult.ResultQueryInfo.UserMessages.length) {
                  this.$notify.error(createResult.savePartnerResp.data.ResultQueryInfo.UserMessages);
                  reject(createResult);
                } else if (createResult.AgreementCode || createResult.LeadId) {
                  this.$notify.info('Заявка отправлена!');
                  resolve(createResult);
                } else {
                  this.$notify.error('Ошибка при отправке')
                  reject({});
                }
              });
            }).then(afterSave).catch(onRejected);
          
      }).catch(() => {
          this.$notify.error('Заполните данные заявки');
      });
    },
    validateRussianPassport(rule, value, callback) {
      if (this.form.passportType !== 2) {
        if (this.leadData.PassportRusSer === '' || this.leadData.PassportRusNumber === '') {
          callback(new Error('Введите серию и номер паспорта'));
        } else if (this.settings.lead.passportValidationType === 'ru') {
          if (!this.leadData.PassportRusSer.match(/^[0-9]{4}$/)
              || !this.leadData.PassportRusNumber.match(/^[0-9]{6}$/)) {
            callback(new Error('Данные паспорта введены неверно'));
          }
        } else if (this.settings.lead.passportValidationType === 'kz') {
          if (!this.leadData.PassportRusSer.match(/^.$/)
              || !this.leadData.PassportRusNumber.match(/^[0-9]{8}$/)) {
            callback(new Error('Данные паспорта введены неверно'));
          }
        }
      }
      
      callback();
    },
    validateForeignPassport(rule, value, callback) {
      if (this.form.passportType !== 1) {
        if (this.leadData.PassportType === '' || this.leadData.PassportNumber === '') {
          callback(new Error('Введите серию и номер паспорта'));
        }

        if (!this.leadData.PassportType.match(/^[0-9]{2}$/)
            || !this.leadData.PassportNumber.match(/^[0-9]{7}$/)) {
          callback(new Error('Данные паспорта введены неверно'));
        }
      }
      
      callback();
    },
    validatePassportDates(rule, value, callback) {
      if (this.form.passportType === 1 && !this.leadData.PassportDate && !this.leadData.PassportDateEnd) {
        callback(new Error('Укажите даты начала и окончания действия загран паспорта'));
      }

      callback();
    },
    validateTouristsCount(rule, value, callback) {
      if (this.leadData.Adults <= 0) {
        callback(new Error('Укажите количество туристов'));
      }
      
      callback();
    },
    validateBudget(rule, value, callback) {
      if (this.leadData.BudgetFrom <= 0 && this.leadData.BudgetTo <= 0) {
        callback(new Error('Укажите бюджет поездки'));
      }
      
      callback();
    },
    validatePhone(rule, value, callback) {
      if (this.leadData.Phone.replace(/\D/g, '').length < 10) {
        callback(new Error('Некорректный номер телефона'));
      }
      
      callback();
    },
    validateEmail(rule, value, callback) {
      if (!String(this.leadData.Email).toLowerCase().match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
        callback(new Error('Некорректный email'));
      }
      
      callback();
    },
  },
  mounted() {
    this.agreementUrl = this.settings.lead.agreementFileId
        ? `${this.settings.connect.host}/TourClient/Report/File?fileId=${this.settings.lead.agreementFileId}&partnerId=${this.settings.connect.partnerId}`
        : this.settings.lead.offertaLink;

    this.policyHtml = this.settings.lead.policyHtml;
    this.pdnHtml = this.settings.lead.pdnHtml;

    if (this.settings.lead.fields.filter(i => i.type === 'country')) {
      axios.get(`${this.settings.connect.host}/tourclient/api/country/${this.settings.connect.partnerId}`)
          .then(countriesResp => {
            this.options.countries = countriesResp.data.Items.map(i => {return {Id: i.Id, Name: i.Name}});
          });
    }
  },
};
</script>
<template>
<div>
  <el-row>
    <el-col align="center">
      <div style="max-width: 500px;">
        <div v-if="isSuccess">
          <h1 :style="settings.style.successMessageStyle">{{settings.lead.successMessage}}</h1>
        </div>
        <div v-else-if="isFailed">
          <h1 :style="settings.style.failedMessageStyle">{{settings.lead.failedMessage}}</h1>
        </div>
        <div v-else>
          <el-form :model="form" :rules="rules" ref="leadForm" v-loading="load">
            <div v-for="field in settings.lead.fields">
              <el-form-item v-if="field.type !== 'passportData'" :label="field.label" :prop="field.type !== 'additional' ? field.type : 'additional_' + field.additionalId">
                <el-input v-if="field.type === 'fullName'" v-model="form.fullName"></el-input>
                <el-input v-if="field.type === 'lastName'" v-model="leadData.LastName"></el-input>
                <el-input v-if="field.type === 'firstName'" v-model="leadData.FirstName"></el-input>
                <el-input v-if="field.type === 'middleName'" v-model="leadData.MiddleName"></el-input>
                <el-input v-if="field.type === 'phone'" v-model="leadData.Phone"></el-input>
                <el-input v-if="field.type === 'email'" v-model="leadData.Email"></el-input>
                <el-input v-if="field.type === 'description'" type="textarea" v-model="leadData.LeadComment"></el-input>
                <el-input v-if="field.type === 'address'" v-model="leadData.Address"></el-input>
                <el-date-picker v-if="field.type === 'birthday'" :picker-options="{firstDayOfWeek:1}" format="dd.MM.yyyy" value-format="yyyy-MM-dd" v-model="leadData.Birthday"></el-date-picker>
                
                <el-select v-if="field.type === 'country'" v-model="leadData.CountryId" placeholder="Выберите страну" filterable>
                  <el-option v-for="cn in options.countries" :value="cn.Id" :key="cn.Id" :label="cn.Name"></el-option>
                </el-select>
                
                <el-date-picker v-if="field.type === 'tourDates'"
                                :picker-options="{firstDayOfWeek:1}"
                                format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="Начало тура"
                                end-placeholder="Конец тура"
                                v-model="form.tourDates">
                </el-date-picker>
                
                <div v-if="field.type === 'touristsCount'">
                  <span v-if="field.labelAdults && field.labelChildren" style="margin-right: 10px;">{{field.labelAdults}} / {{field.labelChildren}}:</span>
                  <el-input-number :min="1" size="mini" controls-position="right" v-model="leadData.Adults"></el-input-number>&nbsp;
                  <el-input-number :min="0" size="mini" controls-position="right" v-model="leadData.Children"></el-input-number>
                </div>

                <el-input-number v-if="field.type === 'adultsCount'" :min="1" v-model="leadData.Adults"></el-input-number>
                <el-input-number v-if="field.type === 'childrenCount'" v-model="leadData.Children"></el-input-number>
                
                <div v-if="field.type === 'budget'">
                  <el-input-number :min="0" :step="1000" size="mini" controls-position="right" v-model="leadData.BudgetFrom"></el-input-number>
                  &nbsp;&nbsp;—&nbsp;&nbsp;
                  <el-input-number :min="0" :step="1000" size="mini" controls-position="right" v-model="leadData.BudgetTo"></el-input-number>
                  &nbsp;&nbsp;руб.
                </div>
                
                <el-input v-if="field.type === 'additional' && field.additionalSource === 'lead' && field.additionalType === 'text'"
                          v-model="leadAdditionalReferences[field.additionalId].Value">
                </el-input>
                <el-checkbox v-if="field.type === 'additional' && field.additionalSource === 'lead' && field.additionalType === 'bool'"
                          v-model="leadAdditionalReferences[field.additionalId].Value">
                </el-checkbox>
              </el-form-item>
              <div v-if="field.type === 'passportData'">
                <el-form-item :label="field.label" :prop="field.type">
                  <div style="display: inline-flex;" v-if="field.type === 'passportData'">
                    <el-select v-if="field.passportType === 'select'" v-model="form.passportType" placeholder="Укажите тип паспорта" filterable>
                      <el-option v-for="cn in options.passportTypes" :value="cn.id" :key="cn.id" :label="cn.name"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
                <div v-if="form.passportType === 1 || field.passportType === 'multiple' || field.passportType === 'rus'">
                  <el-form-item label-position="left" label-width="100" label="Серия и номер" prop="passportRus">
                    <el-input style="float:left;width:70px;" v-model="leadData.PassportRusSer" placeholder="серия"></el-input>
                    <el-input style="margin-left:10px;float:left;width:100px;" placeholder="номер" v-model="leadData.PassportRusNumber"></el-input>
                  </el-form-item>
                  <el-form-item label="Кем выдан" prop="passportRusByWhom">
                    <el-input type="textarea" v-model="leadData.PassportRusByWhom"></el-input>
                  </el-form-item>
                  <el-form-item label-position="left" label-width="100" label="Дата выдачи" prop="passportRusDate">
                    <el-date-picker size="small" :picker-options="{firstDayOfWeek:1}" format="dd.MM.yyyy" value-format="yyyy-MM-dd" v-model="leadData.PassportRusDate"></el-date-picker>
                  </el-form-item>
                </div>
                <div v-if="form.passportType === 2 || field.passportType === 'multiple' || field.passportType === 'foreign'">
                  <el-form-item label-position="left" label-width="100" label="Серия и номер" prop="passportForeign">
                    <el-col :span="10">
                      <el-input style="float:left;width:70px;" v-model="leadData.PassportType"></el-input>
                      <el-input style="margin-left:10px;float:left;width:100px;" v-model="leadData.PassportNumber"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="Кем выдан" prop="passportByWhom">
                    <el-input type="textarea" v-model="leadData.PassportByWhom"></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="passportDates">
                    <el-col :span="5">
                      Дата выдачи
                    </el-col>
                    <el-col :span="6">
                      <el-date-picker style="width: auto;" size="small" :picker-options="{firstDayOfWeek:1}" format="dd.MM.yyyy" value-format="yyyy-MM-dd" v-model="leadData.PassportDate"></el-date-picker>
                    </el-col>
                    <el-col :span="5">
                      Срок действия
                    </el-col>
                    <el-col :span="6">
                      <el-date-picker style="width: auto;" size="small" :picker-options="{firstDayOfWeek:1}" format="dd.MM.yyyy" value-format="yyyy-MM-dd" v-model="leadData.PassportDateEnd"></el-date-picker>
                    </el-col>
                  </el-form-item>
                </div>
                <div v-if="form.passportType === 3 || field.passportType === 'multiple'">
                  <el-form-item label-position="left" label-width="100" label="Номер">
                    <el-col :span="10">
                      <el-input style="margin-left:10px;float:left;width:100px;" v-model="leadData.BirthdayCertificate"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="">
                    <el-col :span="5">
                      Дата выдачи
                    </el-col>
                    <el-col :span="6">
                      <el-date-picker style="width: auto;" size="small" :picker-options="{firstDayOfWeek:1}" format="dd.MM.yyyy" value-format="yyyy-MM-dd" v-model="leadData.BirthdayCertificateDate"></el-date-picker>
                    </el-col>
                  </el-form-item>
                </div>
              </div>
            </div>
            <hr/>
            <el-form-item v-if="agreementUrl" label="">
              <el-checkbox v-model="form.agreeOffer">Согласен на обработку <a :href="agreementUrl">персональных данных</a></el-checkbox>
            </el-form-item>
            <el-form-item v-if="pdnHtml" label="">
              <el-checkbox v-model="form.agreePdn"><span v-html="pdnHtml"></span></el-checkbox>
            </el-form-item>
            <el-form-item v-if="policyHtml" label="">
              <el-checkbox v-model="form.agreePolicy"><span v-html="policyHtml"></span></el-checkbox>
            </el-form-item>
            <el-button v-show="showSubmitButton" :disabled="!form.agreeOffer && agreementUrl || !form.agreePdn && pdnHtml || !form.agreePolicy && policyHtml" @click="handleSubmit">{{settings.lead.submitText}}</el-button>
          </el-form>
        </div>
      </div>
    </el-col>
  </el-row>
</div>
</template>
<style lang="css">

</style>